export default __webpack_public_path__ + "static/media/abbv-page.b14b745c.png";